module.exports = __webpack_public_path__ + "static/media/frame1.b108b789.svg";